const fontHeadline = '"Sage Headline", sans-serif';
const fontText = '"Sage Text", sans-serif';

export default {
    typography: {
        fontFamily: fontText,
        fontFamilyHeadline: fontHeadline,
        defaultText: {
            fontFamily: fontText,
        },
        smallText: {
            fontFamily: fontText,
        },
        largeText: {
            fontFamily: fontText,
        },
        bigText: {
            fontFamily: fontText,
        },
        h1: {
            fontFamily: fontHeadline,
        },
        h2: {
            fontFamily: fontHeadline,
        },
        h3: {
            fontFamily: fontHeadline,
        },
        h4: {
            fontFamily: fontText,
        },
        h5: {
            fontFamily: fontText,
        },
        h6: {
            fontFamily: fontText,
        },
        subtitle1: {
            fontFamily: fontText,
        },
        subtitle: {
            fontFamily: fontText,
        },
        body1: {
            fontFamily: fontText,
        },
        body: {
            fontFamily: fontText,
        },
        button: {
            fontFamily: fontText,
        },
        caption: {
            fontFamily: fontText,
        },
        captionMedium: {
            fontFamily: fontText,
        },
        badges: {
            fontFamily: fontText,
        },
        overline: {
            fontFamily: fontText,
        },
    },
};
